import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-form" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseSection, null, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
          enableCreate: _ctx.enableCreate,
          isAgent: _ctx.isAgent,
          isAccommodation: _ctx.isAccommodation
        }, null, 8, ["enableCreate", "isAgent", "isAccommodation"]))
      ]),
      _: 1
    }),
    (!_ctx.enableCreate && !_ctx.isAgent)
      ? (_openBlock(), _createBlock(_component_BaseSection, { key: 0 }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" Are you an agent? Login ")),
            _createElementVNode("a", { href: _ctx.agentLink }, "here", 8, _hoisted_2)
          ]),
          _: 1,
          __: [0]
        }))
      : _createCommentVNode("", true)
  ]))
}